<template>
  <div id="app">
    <router-view name="header"></router-view>
    <router-view name="home"></router-view>
    <router-view name="aboutContent"></router-view>
    <router-view name="product"></router-view>
    <router-view name="systemSoft"></router-view>
    <router-view name="partnersList"></router-view>
    <router-view name="outlines"></router-view>
    <router-view name="renovation"></router-view>
    <router-view name="partnerDetail"></router-view>
    <router-view name="newsList"></router-view>
    <router-view name="newsDetail"></router-view>
    <router-view name="contactUs"></router-view>
    <router-view name="jobContent"></router-view>
    <router-view name="footer"></router-view>
    <div class="clearFloat"></div>
  </div>
</template>
<script>
export default {
  name: "app",
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  min-width: 1140px;
  text-align: center;
}
#container {
  position: relative;
}
body {
  margin: 0;
  padding: 0;
}
.clearFloat {
  clear: both;
}

/* ::-webkit-scrollbar {
  height: 0;
} */
</style>



// WEBPACK FOOTER //
// App.vue?73dacebc